import Service from "../Service";

const resource = "/person";

export default {
  /**
   * Guardar teléfono de persona
   * @param {Object} obj - Objeto GenPersonTelephone
   * @param {number} requestID - ID del usuario
   */
  save(obj, requestID) {
    return Service.post(`${resource}/telephone/save`, obj, {
      params: { requestID }
    });
  }
};
